import React from 'react';
import "../Footer/Footer.css";
import logo from "../../Images/Woodsy.png";
import { IoLocationSharp } from "react-icons/io5";
import { IoCall } from "react-icons/io5";
import { IoMail } from "react-icons/io5";
import { Link } from 'react-router-dom';
import { MdKeyboardArrowRight } from "react-icons/md";
const Footer = () => {
    return (
        <div>
            <section className='footer-section'>
                <div className='container'>
                    <div className='footer-section-main-con'>
                        <div className='row'>
                            <div className='col-md-3'>
                                <div className='footer-section-logo-main-con'>
                                    <div className='footer-section-logo-image-con'>
                                        <img src={logo} />
                                    </div>
                                    <p>Inspired by nature and structure, representing premium wood solutions with grace and precision.</p>
                                </div>
                            </div>
                            <div className='col-md-3'>
                                <div className='footer-section-items-main-con'>
                                    <h3>our company</h3>
                                    <ul>
                                        <li><MdKeyboardArrowRight /><Link to="/w">Home</Link></li>
                                        <li><MdKeyboardArrowRight /><Link to="/product">Product</Link></li>
                                        <li><MdKeyboardArrowRight /><Link to="/about">About Us</Link></li>
                                        <li><MdKeyboardArrowRight /><Link to="/contact">Contact Us</Link></li>
                                        <li><MdKeyboardArrowRight /><Link to="/terms-conditions">Terms & Conditions</Link></li>
                                        <li><MdKeyboardArrowRight /><Link to="/return-policy">Return and Refund Policy</Link></li>
                                        <li><MdKeyboardArrowRight /><Link to="/shipping">Shipping Policy</Link></li>
                                        <li><MdKeyboardArrowRight /><Link to="/privacy-policy">Privacy Policy</Link></li>
                                    </ul>
                                </div>
                            </div>
                            <div className='col-md-3'>
                                <div className='store-information-main-con'>
                                    <h3>store information</h3>

                                    <div className='store-information-details-main-con'>
                                        <div className='store-information-details-con'>
                                            <div className='store-information-details-con-icons'>
                                                <IoLocationSharp />
                                            </div>
                                            <p><Link>Global lumbers Gala no 48 Sant Savta Marg Mustufa bazaar,opposite Usha Godown,
                                            Byculla East, Mumbai, Maharashtra 400010</Link></p>
                                        </div>
                                        <div className='store-information-details-con'>
                                            <div className='store-information-details-con-icons'>
                                                <IoCall />
                                            </div>
                                            <p><Link>91 76666 66555</Link></p>
                                        </div>
                                        <div className='store-information-details-con'>
                                            <div className='store-information-details-con-icons'>
                                                <IoMail />
                                            </div>
                                            <p><Link>darveshzakia81@gmail.com</Link></p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='col-md-3'>
                                <div className='footer-section-map-main-con'>
                                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3772.988402172582!2d72.8388313!3d18.976119599999997!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7cfb5fe994af1%3A0x4f822394d144cbdc!2sWoodsy!5e0!3m2!1sen!2sin!4v1747740148467!5m2!1sen!2sin" width="100%" height="100%" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                                </div>
                            </div>
                        </div>
                        <div className="follow-us-outer text-center">
                            <ul className="inline-list social-icons">
                                <li>
                                    <a
                                        className="icon-fallback-text"
                                        href='https://www.facebook.com/people/Woodsyofficial/61573711121095/' 
                                        target='blank'
                                        title="Follow us on Facebook"
                                    >
                                        <span className="mdi mdi-facebook" aria-hidden="true" />
                                        <span className="fallback-text">Facebook</span>
                                    </a>
                                </li>
                                <li>
                                    <a
                                        className="icon-fallback-text"
                                        href="https://www.instagram.com/woodsy.official/?fbclid=IwZXh0bgNhZW0CMTEAAR32uMU1VvCrHqTcb2TIJu_lx2iJmlx3o5zLnIFzU1lrTBCUg7IsAmzp__s_aem_ZuflNhluisS6ikGZgnvK5Q"
                                        target='blank'
                                        title="Follow us on Instagram"
                                    >
                                        <span className="mdi mdi-instagram" aria-hidden="true" />
                                        <span className="fallback-text">Instagram</span>
                                    </a>
                                </li>
                                <li>
                                    <a
                                        className="icon-fallback-text"
                                        href="https://wa.me/+917666666555?text="// Replace with your WhatsApp number in international format (e.g. https://wa.me/919999999999)
                                        target='blank'
                                        title="Chat with us on WhatsApp"
                                    >
                                        <span className="mdi mdi-whatsapp" aria-hidden="true" />
                                        <span className="fallback-text">WhatsApp</span>
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <div className='footer-section-copyright'>
                            <p>Copyright © 2025 Theme: <span>WOODSY</span> | Powered by <span>SKDM</span></p>
                            
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default Footer
